import {
  SELECT_CINEMA,
  SELECT_WEEK, SELECT_DATE,
  WEEKS_AND_CINEMAS_REQUESTED,
  WEEK_DETAILS_REQUESTED,
  FILM_DETAILS_REQUESTED,
  SEARCH_MOVIE, SELECT_VIEW,
  TABLE_REQUESTED, CHANGE_DATE,
  OPEN_MODAL, CLOSE_MODAL,
  GET_CURRENT_TIME, REMOVE_SEARCH_FIELD,
  SET_BRAND,
} from 'consts/actionTypes';

export const selectCinema = cinema => ({
  type: SELECT_CINEMA,
  payload: {
    cinema,
  },
});

export const selectWeek = week => ({
  type: SELECT_WEEK,
  payload: {
    week,
  },
});

export const selectDate = date => ({
  type: SELECT_DATE,
  payload: {
    date,
  },
});

export const searchMovie = movie => ({
  type: SEARCH_MOVIE,
  payload: {
    movie,
  },
});

export const getWeeksAndCinemas = () => ({
  type: WEEKS_AND_CINEMAS_REQUESTED,
});

export const getWeekDetails = week => ({
  type: WEEK_DETAILS_REQUESTED,
  payload: {
    week,
  },
});

export const getFilmDetails = filmId => ({
  type: FILM_DETAILS_REQUESTED,
  payload: {
    filmId,
  },
});

export const selectView = view => ({
  type: SELECT_VIEW,
  payload: {
    view,
  },
});

export const getDummyWeek = () => ({
  type: TABLE_REQUESTED,
});

export const changeDate = () => ({
  type: CHANGE_DATE,
});

export const openModal = modalData => ({
  type: OPEN_MODAL,
  payload: {
    modalData,
  },
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});

export const getCurrentTime = () => ({
  type: GET_CURRENT_TIME,
});

export const removeSearchField = () => ({
  type: REMOVE_SEARCH_FIELD,
});

export const setBrand = brand => ({
  type: SET_BRAND,
  payload: {
    brand,
  },
});
